import { render } from "./Ali-Icon.vue?vue&type=template&id=1bafc694"
import script from "./Ali-Icon.vue?vue&type=script&lang=js"
export * from "./Ali-Icon.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__